export default "__VITE_ASSET__DO4SqMYn__"